
import React, { useState } from 'react';

import ButtonCommandTool from './ButtonCommandTool';

const ButtonCommandTools = (props) => {

    const [selectedToolId, setSelectedToolId] = useState(props.tools[0].toolId);

    const getToolById = (toolId) => {
        return props.tools.reduce((previous, current) => {
            return (current.toolId === toolId)
                ? current
                : previous;
        }, null);
    }

    const handleClick = (toolId) => {
        setSelectedToolId(toolId);
        if (props.onSelectTool) {
            props.onSelectTool(toolId, getToolById(toolId));
        }
    }

    return props.tools.map(item => {
        return <ButtonCommandTool
            key={item.toolId}
            toolId={item.toolId}
            iconSrc={item.iconSrc}
            title={item.title}
            selected={selectedToolId === item.toolId}
            onClick={handleClick}
        />
    });
}

export default ButtonCommandTools;
